import type { ModuleOptions } from "@nuxtjs/i18n";
import { baseUrl, defaultLocale } from "../config/canonicalSettings";

export const languageCodes = ["nl", "fr", "en"];

export const i18nConfig = {
  baseUrl: baseUrl,
  defaultLocale: defaultLocale,
  experimental: {
    localeDetector: "localeDetector.ts",
    alternateLinkCanonicalQueries: true,
  },
  locales: [
    {
      code: "nl-be" as const,
      language: "nl",
      name: "Nederlands",
      file: "nl-be.json",
    },
    {
      code: "fr-be" as const,
      language: "fr",
      name: "Français",
      file: "fr-be.json",
    },
  ],
  strategy: "prefix",
  compilation: {
    // allow html in translations
    strictMessage: false,
  },

  // custom config file
  vueI18n: "./i18n-vue.config.ts",

  // https://i18n.nuxtjs.org/guide/custom-paths#example-3-dynamic-routes
  customRoutes: "config",
  pages: {
    "events/[slug]": {
      "nl-be": "/evenementen/[slug]",
      "fr-be": "/evenements/[slug]",
    },
    "news/[slug]": {
      "nl-be": "/nieuws/[slug]",
      "fr-be": "/nouvelles/[slug]",
    },
    "stores/[slug]": {
      "nl-be": "/vestigingen/[slug]",
      "fr-be": "/etablissements/[slug]",
    },
    "trends/[slug]": {
      "nl-be": "/trends-inspiratie/[slug]",
      "fr-be": "/tendances-inspiration/[slug]",
    },
  },
} satisfies ModuleOptions;
